<div [class.disabled]="disabled$ | async" class="form-control search-input">
  <div class="icon search-input__search-icon"></div>
  <input type="text" class="search-input__input" #searchTermInput [formControl]="searchTerm" [placeholder]="placeholder" />
  @if (searchTerm.value && searchTerm.value.length) {
    <div role="button" class="icon search-input__cross-icon" (click)="clearSearchTerm()" data-testid="icon-clear-searchterm"></div>
  }
</div>
